import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Calendar } from 'lucide-react';
import { parseLocalDate } from '../../utils/dateUtils';

const BuyerRegisterModal = ({
  open, onOpenChange, eventToRegister, currentLang, formatPrice, t,
  couponCode, setCouponCode, couponApplied, setCouponApplied, couponLoading,
  couponError, setCouponError, validateCoupon, getDiscountedAmount, resetCouponState,
  registerForEvent,
}) => {
  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) resetCouponState(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('dashboard.register_for_event')}</DialogTitle>
          <DialogDescription>{eventToRegister?.buyer_fee > 0 ? `${t('dashboard.entry_fee')}: ${formatPrice(eventToRegister.buyer_fee)}` : t('dashboard.free_entry')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="bg-slate-50 rounded-lg p-4">
            <h3 className="font-semibold">{eventToRegister?.name}</h3>
            <p className="text-sm text-slate-600 mt-1">{eventToRegister?.description}</p>
            <p className="text-sm text-slate-500 mt-2">
              <Calendar className="inline h-4 w-4 mr-1" />
              {eventToRegister && parseLocalDate(eventToRegister.start_date).toLocaleDateString(currentLang)} - {eventToRegister && parseLocalDate(eventToRegister.end_date).toLocaleDateString(currentLang)}
            </p>
          </div>
          {eventToRegister?.buyer_fee > 0 && eventToRegister?.coupon_enabled && (
            <div className="border rounded-lg p-4 space-y-3">
              <Label className="text-sm font-medium">{t('dashboard.have_coupon')}</Label>
              <div className="flex gap-2">
                <Input placeholder={t('dashboard.enter_coupon')} value={couponCode} onChange={(e) => { setCouponCode(e.target.value); setCouponError(''); }} disabled={!!couponApplied} className="flex-1" />
                {couponApplied ? (
                  <Button variant="outline" onClick={() => { setCouponApplied(null); setCouponCode(''); }}>{t('dashboard.remove')}</Button>
                ) : (
                  <Button onClick={validateCoupon} disabled={!couponCode.trim() || couponLoading}>{couponLoading ? t('dashboard.checking') : t('dashboard.apply_coupon')}</Button>
                )}
              </div>
              {couponError && <p className="text-sm text-red-500">{couponError}</p>}
              {couponApplied && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                  <p className="text-sm text-green-700 font-medium">{t('dashboard.coupon_applied_msg', { percent: couponApplied.discount_percent })}</p>
                  <div className="mt-2 text-sm">
                    <p className="text-slate-600">{t('dashboard.original_price')} {formatPrice(eventToRegister.buyer_fee)}</p>
                    <p className="text-slate-600">{t('dashboard.discount_amount')} -{formatPrice(eventToRegister.buyer_fee * (couponApplied.discount_percent / 100))}</p>
                    <p className="font-semibold text-green-700">{t('dashboard.total_price')} {formatPrice(getDiscountedAmount(eventToRegister.buyer_fee))}</p>
                  </div>
                </div>
              )}
            </div>
          )}
          <p className="text-sm text-slate-600">{t('dashboard.by_registering')}</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => { onOpenChange(false); resetCouponState(); }}>{t('dashboard.cancel')}</Button>
          <Button onClick={registerForEvent}>
            {eventToRegister?.buyer_fee > 0 && getDiscountedAmount(eventToRegister.buyer_fee) > 0 ? t('dashboard.proceed_to_payment') : t('dashboard.register_now')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BuyerRegisterModal;
